<template>
<v-container>
  <v-layout wrap>
    <v-flex xs12>
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>{{ $t('login.title') }}</v-toolbar-title>
        </v-toolbar>

        <v-flex xs12 sm12>
          <v-form>

            <v-flex xs12 sm12 ma-4>
              <v-text-field
                v-model="email"
                ref="email"
                placeholder=" "
                :error=!!errors.email
                :error-messages=errors.email
                :label="`${$t('login.email')}`"
                name="email"
                ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 ma-4>
              <v-text-field
                v-model="password"
                type="password"
                ref="password"
                placeholder=" "
                :error=!!errors.password
                :error-messages=errors.password
                :label="`${$t('login.password')}`"
                name="password"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 ma-4>
              <v-checkbox
                v-model="remember"
                :label="`${$t('login.remember')}`"
                ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm12 ma-4>
              <v-btn class="login" color="accent" :aria-label="$t('login.login')" @click="login">{{ $t('login.login') }}</v-btn>
              <v-btn :aria-label="$t('login.forgot_password')" @click="$router.push({name: 'forgot-password'})">{{ $t('login.forgot_password') }}</v-btn>
            </v-flex>
          </v-form>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  name: 'Login',

  created () {
    this.$ga.page(this.$router)
  },

  mounted () {
    let self = this
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        self.login()
      }
    })
  },

  data () {
    return {
      error: false,
      errors: [],
      isLoading: false,
      email: '',
      remember: '',
      selected: '',
      password: ''
    }
  },

  methods: {
    login: function () {
      var self = this
      this.isLoading = true
      this.$auth.login({
        params: { 'email': this.email, 'password': this.password },
        success: function () {
          self.isLoading = false
        },
        error: function () {
          this.$store.dispatch('Alert/newAlert', { type: 'error', message: this.$t('errors.login') })
          self.$data.isLoading = false
          self.$data.error = true
        },
        rememberMe: true,
        redirect: '/',
        fetchUser: true
      })
    }
  }
}
</script>
